import $ from 'jquery';
import { smoothscroll } from '../utils/smoothscroll';

const $document = $(document);

$document.on('click', '.post-card__comment-trigger', function () {
    const $trigger = $(this);
    const $comments = $trigger.closest('.post-card').find('.post-card__comments');

    if ($comments.is(':hidden')) {
        $comments.slideDown(
            {
                start: function () {
                    $comments.css({
                        display: 'flex',
                    });
                },
                done: function () {
                    if ($trigger.hasClass('with-focus')) {
                        $comments.find('.post-card__input').trigger('focus');
                    }
                },
            },
            300
        );
    } else {
        $comments.slideUp(300);
    }
});

$(() => {
    const queryString = window.location.search;

    if (new RegExp('postId=[0-9]+').test(queryString)) {
        smoothscroll('.post-card', 'header');
    }
});
